import { Row, Col, Card } from 'antd'
import React, { useMemo } from 'react'
import { StyledCard } from '../../../styled-components/Card'
import { StyledTypographyTitle } from '../../../styled-components/Typography'
import OverviewTableQuestionnaireFullReport from './OverviewTableQuestionnaireFullReport'
import RadarChartDashboard from '../../dashboard/RadarChartDashboard'
import styled from 'styled-components'
import { UseOverviewTableQuestionnaireReport } from './OverviewTableQuestionnaireReport'

const Container = styled.div({
    width: 580,
    height: 580,
})

const toDataChart = (
    data: DataSource[],
    questionnaireID: number | string,
    mode: string | undefined,
    fullScore: number,
) => {
    return data.map((item) => {
        if (mode === 'dimension') {
            return {
                ...item,
                assessmentId: questionnaireID,
                dimensionId: item.id,
                dimensionName: item.name,
            }
        } else {
            return {
                ...item,
                assessmentId: questionnaireID,
                dimensionId: item.dimensionID,
                dimensionName: item.purposeName,
                name: item.purposeName,
                scoreFull: fullScore,
            }
        }
    })
}

export type DataSource = {
    id: number
    name: string
    scoreFull: number
    scoreUser: number | null
    scoreAdmin: number | null
    // gradeUser: string | null
    // gradeAdmin: string | null
    descriptionAdmin: string | null | undefined
    descriptionUser: string | null | undefined
    [key: string]: any
}

type ReturnTypeUseOverviewSummaryReport = ReturnType<typeof useOverviewSummaryReport>

type UseOverviewSummaryReport = {
    containerRef?: React.RefObject<HTMLElement> | undefined
    title: string
    fullScore: number
    questionnaireID: number
    dataSource?: DataSource[]
    order?: number
    mode?: string
} & UseOverviewTableQuestionnaireReport
const useOverviewSummaryReport = ({ dataSource = [], questionnaireID, mode, fullScore }: UseOverviewSummaryReport) => {
    const dataChart = useMemo(
        () => toDataChart(dataSource, questionnaireID, mode, fullScore),
        [dataSource, questionnaireID], // eslint-disable-line react-hooks/exhaustive-deps
    )
    return { dataChart }
}

type OverviewSummaryReportViewProps = { mode?: 'purpose' | 'dimension' } & UseOverviewSummaryReport &
    ReturnTypeUseOverviewSummaryReport

const OverviewSummaryReportView: React.FC<OverviewSummaryReportViewProps> = ({
    title,
    containerRef,
    fullScore,
    questionnaireID,
    dataChart,
    dataSource,
    mode = 'dimension',
    prefixLabel,
    titleCell,
}) => {
    return (
        <StyledCard bordered={false} bodyStyle={{ overflow: 'auto' }}>
            <div>
                <StyledTypographyTitle
                    styled={{
                        fontFamily: 'THSarabunNew',
                        fontSize: 30,
                        textAlign: mode === 'dimension' ? 'center' : 'left',
                    }}
                    level={2}
                >
                    {title}
                </StyledTypographyTitle>
                <Row justify='center'>
                    <Col>
                        <Container
                            //@ts-ignore
                            ref={containerRef}
                        >
                            <RadarChartDashboard
                                radarProps={{
                                    // tooltipDisplay: mode === 'dimension',
                                    fontFamily: 'THSarabunNew',
                                }}
                                displayPoint={mode === 'dimension'}
                                color={mode === 'dimension' ? undefined : []}
                                options={{
                                    fullScore,
                                    prefixLabel,
                                    assessmentId: questionnaireID,
                                    //@ts-ignore
                                    dimensions: dataChart,
                                }}
                            />
                        </Container>{' '}
                    </Col>
                </Row>
            </div>
            <div className='page-break' />

            <Card style={{ marginTop: 16 }} bordered={false} bodyStyle={{ padding: 0 }}>
                <OverviewTableQuestionnaireFullReport
                    //@ts-ignore
                    dataSource={dataSource}
                    prefixLabel={prefixLabel}
                    titleCell={titleCell}
                />
            </Card>
        </StyledCard>
    )
}

type OverviewSummaryReportProps = {} & UseOverviewSummaryReport &
    Omit<OverviewSummaryReportViewProps, keyof ReturnTypeUseOverviewSummaryReport>
const OverviewSummaryReport: React.FC<OverviewSummaryReportProps> = (props) => {
    const state = useOverviewSummaryReport(props)
    return <OverviewSummaryReportView {...props} {...state} />
}

export default OverviewSummaryReport
